import {PAGE_TYPES} from '../localization/config';

export const ROUTE_CONFIG = {
  '/mysettings': PAGE_TYPES.PROFILE,
  '/myrefundrequests': PAGE_TYPES.REFUND_RAISE_REQUEST,
  '/mysuppliersettings': PAGE_TYPES.SUPPLIER_SETTINGS,
  '/agent/gstinvoice': PAGE_TYPES.GST_INVOICE_REPORT,
  '/agent/transactionreport': PAGE_TYPES.COMMISSION_REPORT,
} as const;
